// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__cKYBD","img":"styles_img__l_I1b","textWrap":"styles_textWrap__jEK78","title":"styles_title__vEf_D","content":"styles_content__FLvWx"};